import { render, staticRenderFns } from "./form-edit.vue?vue&type=template&id=1b986fb6&scoped=true&"
import script from "./form-edit.vue?vue&type=script&lang=js&"
export * from "./form-edit.vue?vue&type=script&lang=js&"
import style0 from "./form-edit.vue?vue&type=style&index=0&id=1b986fb6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b986fb6",
  null
  
)

export default component.exports